import SparklesIcon from '@assets/images/icons/sparkles.svg';
import { Skeleton } from '@mui/material';
import { MotionImage, MotionText } from '@shared/atoms';
import React from 'react';
import styles from './index.module.scss';

interface AiRecommendedActionsProps {
  actions: string[];
  isLoading: boolean;
  skeletonCount: number;
}

export const AiRecommendedActions: React.FC<AiRecommendedActionsProps> = ({
  actions,
  isLoading,
  skeletonCount,
}) => {
  const containerClasses = styles.recommendedNextActionsContainer;

  if (isLoading) {
    return (
      <div className={containerClasses}>
        {Array.from({ length: skeletonCount }, (_, index) => (
          <Skeleton
            key={`skeleton-${index}`}
            className={styles.recommendedAction}
            variant="rounded"
            width="100%"
            height="20px"
          />
        ))}
      </div>
    );
  }

  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className={containerClasses}>
      {actions.map((action, index) => (
        <div key={`action-${index}`} className={styles.recommendedAction}>
          <MotionImage
            src={SparklesIcon}
            alt=""
            aria-hidden="true"
            className={styles.icon}
            style={{
              filter:
                'invert(62%) sepia(92%) saturate(1064%) hue-rotate(10deg) brightness(91%) contrast(102%)',
            }}
          />
          <MotionText as="text" text={action} />
        </div>
      ))}
    </div>
  );
};
